document.addEventListener('DOMContentLoaded', function(){
    window.onload = function() {
        let checkedVar = document.querySelector('input[name="ctm_variant_input"]:checked');
        if (checkedVar) {
            let varFormInput = checkedVar.closest('.product__info-container').querySelector('product-form form[action="/cart/add"]')?.querySelector('input[name="id"]');
            if(varFormInput) {
                varFormInput.value = checkedVar.value;
                varFormInput.dataset.selectedId = checkedVar.value;
            }
        }
    }

    document.querySelectorAll('input[name="ctm_variant_input"]')?.forEach((varInput)=>{
        varInput.addEventListener('change', function(){
            let ctm_price_container = this.closest('.shopify-section').querySelector('.product__info-container .price__container .price__sale');
            let varFormInput = this.closest('.product__info-container')?.querySelector('product-form form[action="/cart/add"]')?.querySelector('input[name="id"]');
            if(varFormInput) {
                varFormInput.value = this.value;
                varFormInput.dataset.selectedId = this.value;
            }
            
            this.closest('.shopify-section').querySelectorAll('.product__media-wrapper .thumbnail-list .thumbnail-list__item')?.forEach((thumbImg)=>{
                if (thumbImg.dataset.mediaPosition === this.dataset.variant_img) {
                    // console.log("first thumb img : ", thumbImg)
                    thumbImg?.querySelector('button.thumbnail').click()
                }
            })

            this.closest('.shopify-section').querySelectorAll('.featured-product .product__media-wrapper .product__media-list .product__media-item')?.forEach((thumbImg)=>{
                if (thumbImg.dataset.mediaPosition === this.dataset.variant_img) {
                    // console.log("first thumb img : ", thumbImg)
                    // thumbImg?.querySelector('button.thumbnail').click()
                    thumbImg.style.display = 'flex';
                } else {
                    thumbImg.style.display = 'none';
                }
            })
            ctm_price_container.querySelector('.price-item--sale').innerHTML = this.dataset.variant_selling_price;
            ctm_price_container.querySelector('.price__compare-price .price-item--regular').innerHTML = this.dataset.variant_compare_price;
            // console.log("this variant : ", this.closest('.shopify-section').querySelector('.product__info-container .price__container .price__sale'))
            // console.log("this variant : ", this.closest('.shopify-section'))
        });
    });

})